import React from 'react'
import { useHistory } from 'react-router-dom'
import Table from 'components/Shared/Table'
import { useErrorHandling } from 'context/errorHandling'
import { HTTP_404_ERROR } from 'Constants'
import { deleteContractor, fetchContractorsPage } from 'services/ContractorService'
import { useTranslation } from 'react-i18next'
import { CONTRACTOR_CREATE, CONTRACTOR_DELETE, CONTRACTOR_EDIT, useAuth } from 'context/auth'
import { createColumns } from './columns'

export function ContractorsTable () {
  let history = useHistory()
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  const { handleError } = useErrorHandling()

  const addContactor = () => {
    history.push('/contractors/create')
  }

  const showDetails = (row) => {
    history.push('/contractors/details/' + row.id)
  }

  const editContractor = (row) => {
    history.push('/contractors/edit/' + row.id)
  }

  const onDeleteError = (error) => {
    handleError(error, {
      [HTTP_404_ERROR]: 'notifications.error.delete'
    })
  }

  const addButton = {
    label: 'contractor.table.addButtonLabel',
    onClick: addContactor,
    isClickable: hasAnyPrivileges([CONTRACTOR_CREATE])
  }
  const menuOptions = {
    edit: {
      onClick: editContractor,
      isEditable: () => hasAnyPrivileges([CONTRACTOR_EDIT])
    },
    delete: {
      onDelete: deleteContractor,
      onDeleteError: onDeleteError,
      deleteDialog: {
        content: 'contractor.table.deleteDialog.content',
        title: 'contractor.table.deleteDialog.title'
      },
      isDeletable: () => hasAnyPrivileges([CONTRACTOR_DELETE])
    }
  }

  return (
    <Table title={'contractor.table.title'}
           addButton={addButton}
           fetchData={fetchContractorsPage}
           columns={createColumns(hasAnyPrivileges, t)}
           tableKey={'contractors'}
           onRowClick={showDetails}
           menu={menuOptions}
    />
  )
}
